import React from 'react';
import './Stories.css';

/**
 * Компонент для отображения превью историй в виде карусели
 * Отвечает только за отображение карточек историй без логики просмотра
 */
const StoriesCarousel = ({ 
  stories, 
  loading, 
  error, 
  onStorySelect 
}) => {
  // Если идет загрузка, но историй еще нет, показываем лоадер
  if (loading && stories.length === 0) {
    return (
      <div className="stories-container">
        <div className="stories-loading">
          <div className="stories-loader"></div>
        </div>
      </div>
    );
  }

  // Если есть ошибка и историй нет, показываем ошибку
  if (error && stories.length === 0) {
    return (
      <div className="stories-container">
        <div className="stories-error">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  // Если загрузка завершена, ошибки нет, но историй все равно нет
  if (!loading && !error && stories.length === 0) {
    return (
      <div className="stories-container">
        <div className="stories-empty">
          <p>Нет доступных историй</p>
        </div>
      </div>
    );
  }

  // Если есть истории (даже если loading=true для фонового обновления), показываем их
  if (stories.length > 0) {
    return (
      <div className="stories-container">
        <div className="stories-carousel">
          {stories.map((story, index) => (
            <div
              key={story.id}
              className="story-preview"
              onClick={() => onStorySelect(index)}
            >
              <div className="story-preview-ring" style={{ background: story.backgroundColor }}>
                <span className="story-preview-emoji">{story.emoji}</span>
                <span className="story-preview-title">{story.title || `История ${index + 1}`}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Если ни одно из предыдущих условий не выполнено (например, loading=true, но stories.length > 0),
  // или если stories.length === 0, но нет ошибки и загрузка не идет (этот случай уже покрыт выше, но для полноты)
  // Возвращаем null или пустой фрагмент, чтобы ничего не рендерить, если нет историй и нет состояния загрузки/ошибки
  // Однако, по логике выше, если stories.length > 0, они уже должны быть отрендерены.
  // Этот блок фактически не должен достигаться, если логика выше верна.
  return null; 
};

export default StoriesCarousel;
